var map = {
	"./nav-list.de-CH.json": 1133,
	"./nav-list.de-DE.json": 1134,
	"./nav-list.en-CA.json": 1135,
	"./nav-list.en-GB.json": 1136,
	"./nav-list.en-IN.json": 1137,
	"./nav-list.en-ME.json": 1138,
	"./nav-list.en-US.json": 1139,
	"./nav-list.es-EM.json": 1140,
	"./nav-list.es-ES.json": 1141,
	"./nav-list.fr-BE.json": 1142,
	"./nav-list.fr-CA.json": 1143,
	"./nav-list.fr-CH.json": 1144,
	"./nav-list.nl-BE.json": 1145,
	"./nav-list.nl-NL.json": 1146,
	"./nav-list.pl-PL.json": 1147,
	"./nav-list.pt-BR.json": 1148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1132;